// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c86a31d8","952":"3ed35c2c"}[chunkId] + ".chunk.js";
};